interface ProgressBarProps {
    itemCount: number,
    itemIndex: number,
}

function ProgressBar(props: ProgressBarProps): JSX.Element {
    let percentage = Math.round(((props.itemIndex / props.itemCount)*100));
    let width = "max-w-" + percentage + "%";
    
    return (
        <div className="ml-2 mr-2 w-full bg-gray-200 rounded-full mb-2 lg:mb-3 2xl:mb-4 6xl:mb-6 10xl:mb-8">
            <div className={"bg-teal-500 text-xs lg:text-sm 4xl:text-base 6xl:text-lg 7xl:text-xl 8xl:text-2xl 9xl:text-3xl 10xl:text-4xl font-medium text-white text-center rounded-full " + width}>{props.itemIndex + "/" + props.itemCount}</div>
        </div>
    );
}

export default ProgressBar;